import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/hzwjw");

const noLoginAsync = (param) => {
    return remoteCall.invoke("noLogin", param);
};

const bindMobileByIdCardAsync = (param) => {
    return remoteCall.invoke("bindMobileByIdCard", param);
};


export default {
    noLoginAsync,
    bindMobileByIdCardAsync,
};
